import { useTranslation } from "react-i18next";
import MoongyWallpaper from "../../layout/Moongy/background_teams-04.jpg";
import "./DOCOnline.scss";

const DOCOnlineError = ({ errorMessage }) => {
  const { t } = useTranslation();

  return (
    <div className="error-wallpaper">
      <img src={MoongyWallpaper} alt="moongy-error-wallpaper" />
      <p>
        {errorMessage ||
          t(
            "There was an error while trying to display the Doc Online, please contact the responsible manager."
          )}
      </p>
    </div>
  );
};

export default DOCOnlineError;
